import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { ButtonVariant } from '../button/button-classes.util';
import type { IconButtonDensity } from '../icons/action-icon';

/** Transfer / swap arrows. Glyph and hit target come from `app-icon-button`. */
@Component({
  selector: 'app-transfer-icon-button',
  template: `
    <app-icon-button
      name="transfer"
      [variant]="variant"
      [density]="density"
      [ariaLabel]="ariaLabel"
      [title]="title"
      [disabled]="disabled"
      [loading]="loading"
      (onClick)="onClick.emit($event)"
    ></app-icon-button>
  `,
  styles: [':host { display: inline-flex; flex: 0 0 auto; vertical-align: middle; max-width: 100%; }'],
})
export class TransferIconButtonComponent {
  @Input() variant: ButtonVariant = 'secondary';
  @Input() density: IconButtonDensity = '';
  @Input() ariaLabel = '';
  @Input() title = '';
  @Input() disabled = false;
  @Input() loading = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
